module.exports = __webpack_public_path__ + "media/images/img_ttl-bootcamp-3c35b4acf74bb98a02312f4b774b79c4.png";